import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { USER_URL } from "../../constant/api";
import { useNavigate, useParams } from "react-router-dom";

const AddSponsorPackage = ({ Edit = false }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [packageName, setPackageName] = useState("");
  const [period, setPeriod] = useState("");
  const [amount, setAmount] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  // Fetch existing data for edit
  useEffect(() => {
    if (Edit && id) {
      const fetchPackage = async () => {
        try {
          setLoading(true);
          const response = await USER_URL.get(
            `/products/admin/packages/${id}/`,
          );
          const pkg = response.data.Data;
          setPackageName(pkg.name);
          setPeriod(pkg.period);
          setAmount(pkg.price);
        } catch (error) {
          console.error("Error fetching package:", error);
          toast.error("Error loading package.");
        } finally {
          setLoading(false);
        }
      };

      fetchPackage();
    }
  }, [Edit, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};

    if (!packageName.trim()) errors.packageName = "Package name is required";
    if (!period) errors.period = "Period is required";
    if (!amount || isNaN(amount) || Number(amount) <= 0)
      errors.amount = "Enter a valid amount";

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setLoading(true);

    const formData = {
      name: packageName,
      period,
      price: Number(amount),
      promotion_type: "Sponsored",
    };

    try {
      if (Edit && id) {
        await USER_URL.patch(`/products/admin/packages/${id}/`, formData);
        toast.success("Package updated successfully!");
      } else {
        await USER_URL.post("/products/admin/packages/", formData);
        toast.success("Package added successfully!");
        setPackageName("");
        setPeriod("");
        setAmount("");
      }

      navigate("/admin/packages/sponsor");
    } catch (error) {
      console.error("Error saving package:", error);
      toast.error("Failed to save package.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex h-full w-full flex-col gap-4">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col items-center justify-center gap-4"
      >
        <h2 className="text-3xl font-medium text-brand-primary">
          Add Sponsor Package
        </h2>
        <div className="flex w-full max-w-md flex-col gap-2">
          <label htmlFor="packageName" className="text-lg">
            Package Name
          </label>
          {formErrors.packageName && (
            <p className="text-sm text-red-500">{formErrors.packageName}</p>
          )}
          <input
            id="packageName"
            type="text"
            value={packageName}
            onChange={(e) => setPackageName(e.target.value)}
            placeholder="Package name"
            className="rounded-md border p-2"
          />

          <label htmlFor="period" className="text-lg">
            Period
          </label>
          {formErrors.period && (
            <p className="text-sm text-red-500">{formErrors.period}</p>
          )}
          <select
            id="period"
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            className="rounded-md border p-2"
          >
            <option value="" disabled>
              Select a period
            </option>
            <option value="Daily">One Day</option>
            <option value="Weekly">One Week</option>
            <option value="Monthly">One Month</option>
          </select>

          <label htmlFor="amount" className="text-lg">
            Amount
          </label>
          {formErrors.amount && (
            <p className="text-sm text-red-500">{formErrors.amount}</p>
          )}
          <input
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            className="rounded-md border p-2"
          />

          <button
            type="submit"
            disabled={loading}
            className="mt-4 rounded-md bg-brand-primary px-4 py-2 text-white hover:bg-brand-primary/90 disabled:opacity-60"
          >
            {loading
              ? Edit
                ? "Updating..."
                : "Submitting..."
              : Edit
                ? "Update"
                : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSponsorPackage;
